// Contract status is computed dynamically based on the projects statuses
export enum ContractStatusEnum {
  NotStarted = 'NotStarted',
  InProgress = 'InProgress',
  Completed = 'Completed',
}
